export default __webpack_public_path__ + "static/media/brand_twirl.ba21a3b0.svg";